/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Checkout_Before_CheckinInputs */

const en_orders_logistics_checkout_before_checkin = /** @type {(inputs: Orders_Logistics_Checkout_Before_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver check-out cannot be earlier than check-in.`)
};

const es_orders_logistics_checkout_before_checkin = /** @type {(inputs: Orders_Logistics_Checkout_Before_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La salida del chofer no puede ser antes de la entrada.`)
};

/**
* | output |
* | --- |
* | "Driver check-out cannot be earlier than check-in." |
*
* @param {Orders_Logistics_Checkout_Before_CheckinInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_checkout_before_checkin = /** @type {((inputs?: Orders_Logistics_Checkout_Before_CheckinInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Checkout_Before_CheckinInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_checkout_before_checkin(inputs)
	return es_orders_logistics_checkout_before_checkin(inputs)
});